<div class="flex-display font height-100per" aria-label="AICPA">
  <div class="width-70 float-L view-height-overflow">
    <div class="pd-left">
    <header class="aicpa-top-heading content-blue" role="heading" aria-level="2">{{header}}</header>

    <div class="flex-display mb-24px mt-40px info-box">
      <div class="ml-12"><img src="../../../assets/icons/Info..svg" class="info-img" alt="GARS Info"></div>
      <label class="ml-8 para-content content-blue" (click)="openRouterLink($event)" [innerHTML]="subtext"></label>
    </div>

    <div class="mb-24px mt-40px">
      <label class="para-content font-16">{{description}}</label>
    </div>

    <div class="mb-24px mt-40px">
      <label class="para-content font-16" [innerHTML]="accordionSubHeading1"></label>
    </div>

    <mat-accordion class="mb-24px mt-40px">
      <mat-expansion-panel *ngFor="let item of topAccordionMini" (opened)="accordionOpenEvent(item.key)" (closed)="accordionCloseEvent(item.key)">
        <mat-expansion-panel-header class="mataccordianHeader">
          <div class="matheadertext" [id]="item.header" [innerHTML]="item.header"></div>
        </mat-expansion-panel-header>
        <div class="list-items-accordion" *ngFor="let i of item.content">
          <span class="para-content" (click)="openLinkById($event)" [innerHTML]="i.paragraph" (keyup.enter)="openLinkById($event)" tabindex="0"></span>
        </div>
      </mat-expansion-panel>
    </mat-accordion>

    <div class="mb-24px mt-40px">
      <label class="para-content font-16" [innerHTML]="accordionSubHeading2"></label>
    </div>

    <mat-accordion class="mb-24px mt-40px">
      <mat-expansion-panel *ngFor="let item of bottomAccordionMini" (opened)="accordionOpenEvent(item.key)" (closed)="accordionCloseEvent(item.key)">
        <mat-expansion-panel-header class="mataccordianHeader">
          <div class="matheadertext" [id]="item.header" [innerHTML]="item.header"></div>
        </mat-expansion-panel-header>
        <div class="list-items-accordion" *ngFor="let i of item.content">
          <span class="para-content" (click)="openLinkById($event)" [innerHTML]="i.paragraph" (keyup.enter)="openLinkById($event)" tabindex="0"></span>
        </div>
      </mat-expansion-panel>
    </mat-accordion>


    <div class="mb-24px mt-40px bold">
      <article class="para-content font-16" [innerHTML]="notesHeader"></article>
    </div>

    <div class="mb-24px">
      <label class="para-content font-16" [innerHTML]="notesBody"></label>
    </div>

    <div class="mb-24px mt-40px bold">
      <article class="para-content font-16" [innerHTML]="copyrightNoticeHeader"></article>
    </div>

    <div class="mb-2">
      <label class="para-content font-16" [innerHTML]="copyrightNoticeBody"></label>
    </div>
  </div>
  </div>

  <div class="right-panel-no-height float-R">
    <div class="superseded-padding">
      <div class="for-information-on-h pb-16">
        <span [innerHTML]="archiveLibraryBody"></span>
        <img src="../../../assets/icons/Downloads.svg" class="download-image" alt="download icon">
        <span [innerHTML]="archiveLibraryLink"></span>
      </div>
  
      <!--pagination-->
      <div class="pagination-container">
        <div class="pagination-pages" *ngFor="let i of paginationContent">
          <div class="pagination-link">
            <span class="index-link" [ngClass]="{'selected-Index': i === selectedIndex }" [innerHTML]="i" (click)="paginationClick($event)" (keyup.enter)="paginationClick($event)" tabindex="0"></span><br />
          </div>
        </div>
      </div>
    </div>
   
  </div>

</div>
